module.exports = {

    localTimezone: "Asia/Karachi"

}